module.exports = __webpack_public_path__ + "img/team.6b29710e.png";